import React from 'react'
import { graphql, Link } from 'gatsby'
import SEO from '../components/seo'
import Img from 'gatsby-image'
import styled from 'styled-components'
import ProjectNav from '../components/projectNav'
import FbzNav from '../components/fbzNav'
import JorjaNav from '../components/jorjaNav'

const PostSection = styled.div`
  margin: 2em 0;
  display: grid;
  grid-template-columns: auto 3fr 1fr;
  grid-gap: 3em;

  div:first-child {
    @media screen and (max-width: 800px) {
      order: 2;
    }
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`

const ImageSection = styled.div`
  max-width: 700px;
  margin: 0 auto 2em auto;

  @media screen and (max-width: 800px) {
    order: 1;
  }
`
const ContentSection = styled.div`
  max-width: 700px;
  margin: 0 auto 2em auto;
`

const Title = styled.h1`
  font-weight: normal;
  text-transform: uppercase;
  position: sticky;
  top: 103px;
  height: 36px;
  line-height: 1.4;
`

const ArticlePage = ({ data }) => {
  const collection = data.prismicPersonal
  const images =
    collection.data.title.text === 'Jorja Smith' ? null : (
      <div>
         {collection.data.gallery.map(node => (
              <ImageSection key={node.id}>
                 <Img
              fluid={node.image.localFile.childImageSharp.fluid}
            />
                {/* <Img fluid={image.fluid} key={image.id} alt={image.title} /> */}
              </ImageSection>
            ))}
      </div>
    )
  const menu =
    collection.data.fbz === true ? (
      <div>
        <FbzNav />
      </div>
    ) : collection.data.jorja === true ? (
      <div>
        {' '}
        <JorjaNav />
      </div>
    ) : (
      <div>
        <ProjectNav />
      </div>
    )

  return (
    <>
      <SEO
        title={collection.data.title.text}
        image={collection.data.gallery[0].image.url} 
      />
      <PostSection>
        {menu}

        <div>
          {images}

          {/* {collection.postContentNode && 
            <ContentSection
            dangerouslySetInnerHTML={{
              __html: collection.postContentNode.childMarkdownRemark.html,
            }}
          />
          } */}
        </div>

        <Title>
          {' '}
          <Link to="/personal">Personal</Link> /{collection.data.title.text}
        </Title>
      </PostSection>
    </>
  )
}

export const query = graphql`
  query($id: String!) {
    prismicPersonal(id: { eq: $id }) {
      id
      uid
      data {
        fbz
        jorja

        title {
          text
        }

        gallery {
        image {
          url
          localFile {
            publicURL
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
       
      }
    }
  }
`

export default ArticlePage
